import React, { useEffect, useState } from 'react';
import styles from '../ItemModal/ItemModal.module.css';

export const SharingItemModal = ({ isOpen, onClose, onSubmit, item = null }) => {
	const [title, setTitle] = useState('');
	const [img, setImg] = useState('');
	const [P2_price, setP2Price] = useState('');
	const [P3_PS4_price, setP3PS4Price] = useState('');
	const [P3_PS5_price, setP3PS5Price] = useState('');
	const [P2_price_disc, setP2PriceDisc] = useState('');
	const [P3_PS4_price_disc, setP3PS4PriceDisc] = useState('');
	const [P3_PS5_price_disc, setP3PS5PriceDisc] = useState('');
	const [lang, setLang] = useState('');
	const [inMainSlider, setInMainSlider] = useState(false);
	const [rating, setRating] = useState('');
	const [categories, setCategories] = useState('');
	const [devices, setDevices] = useState('');
	const [type, setType] = useState('');

	useEffect(() => {
		if (item) {
			setTitle(item.title || '');
			setImg(item.img || '');
			setP2Price(item.P2_price || '');
			setP3PS4Price(item.P3_PS4_price || '');
			setP3PS5Price(item.P3_PS5_price || '');
			setP2PriceDisc(item.P2_price_disc || '');
			setP3PS4PriceDisc(item.P3_PS4_price_disc || '');
			setP3PS5PriceDisc(item.P3_PS5_price_disc || '');
			setLang(item.lang || '');
			setInMainSlider(item.inMainSlider !== undefined ? item.inMainSlider : true);
			setRating(item.rating || '');
			setCategories(item.categories?.map(c => c.title).join(', ') || '');
			setDevices(item.devices?.map(d => d.title).join(', ') || '');
			setType(item.type || '');
		} else {
			setTitle('');
			setImg('');
			setP2Price('');
			setP3PS4Price('');
			setP3PS5Price('');
			setP2PriceDisc('');
			setP3PS4PriceDisc('');
			setP3PS5PriceDisc('');
			setLang('');
			setInMainSlider(true);
			setRating('');
			setType('')
		}
	}, [isOpen, item]);

	if (!isOpen) return null;

	const handleSubmit = () => {
		const formData = new FormData();
		formData.append('title', title);
		formData.append('img', img);
		formData.append('P2_price', parseFloat(P2_price) || null);
		formData.append('P3_PS4_price', parseFloat(P3_PS4_price) || null);
		formData.append('P3_PS5_price', parseFloat(P3_PS5_price) || null);
		formData.append('P2_price_disc', parseFloat(P2_price_disc) || null);
		formData.append('P3_PS4_price_disc', parseFloat(P3_PS4_price_disc) || null);
		formData.append('P3_PS5_price_disc', parseFloat(P3_PS5_price_disc) || null);
		formData.append('lang', lang);
		formData.append('inMainSlider', inMainSlider ? 'true' : 'false');
		formData.append('rating', parseFloat(rating));
		formData.append('category', categories)
		formData.append('devices', devices)
		formData.append('type', type)

		if (item) {
			formData.append('id', item.id);
			onSubmit(formData, item.id);
		} else {
			onSubmit(formData);
		}
	};

	return (
		<div className={styles.overlay}>
			<div className={styles.modal}>
				<h2>{item ? 'Редактировать Sharing-игру' : 'Добавить Sharing-игру'}</h2>
				<form>
					<input
						name="title"
						placeholder="Название"
						value={title}
						onChange={(e) => setTitle(e.target.value)}
						required
					/>
					<input
						name="img"
						placeholder="Ссылка на изображение"
						value={img}
						onChange={(e) => setImg(e.target.value)}
					/>
					<input
						name="P2_price"
						type="number"
						placeholder="П2 цена"
						value={P2_price}
						onChange={(e) => setP2Price(e.target.value)}
					/>
					<input
						name="P3_PS4_price"
						type="number"
						placeholder="P3 PS4 цена"
						value={P3_PS4_price}
						onChange={(e) => setP3PS4Price(e.target.value)}
					/>
					<input
						name="P3_PS5_price"
						type="number"
						placeholder="P3 PS5 цена"
						value={P3_PS5_price}
						onChange={(e) => setP3PS5Price(e.target.value)}
					/>
					<input
						name="P2_price_disc"
						type="number"
						placeholder="П2 цена со скидкой"
						value={P2_price_disc}
						onChange={(e) => setP2PriceDisc(e.target.value)}
					/>
					<input
						name="P3_PS4_price_disc"
						type="number"
						placeholder="P3 PS4 цена со скидкой"
						value={P3_PS4_price_disc}
						onChange={(e) => setP3PS4PriceDisc(e.target.value)}
					/>
					<input
						name="P3_PS5_price_disc"
						type="number"
						placeholder="P3 PS5 цена со скидкой"
						value={P3_PS5_price_disc}
						onChange={(e) => setP3PS5PriceDisc(e.target.value)}
					/>
					<input
						name="lang"
						placeholder="Язык"
						value={lang}
						onChange={(e) => setLang(e.target.value)}
					/>
					<input
						name="type"
						placeholder="Тип (sub or game)"
						value={type}
						onChange={(e) => setType(e.target.value)}
					/>

					<h3 className={styles.titleH3}>На главном слайдере:</h3>
					<div className={styles.checkboxLabel}>
						<p>Показывать</p>
						<input
							type="checkbox"
							checked={inMainSlider}
							onChange={(e) => setInMainSlider(e.target.checked)}
						/>
					</div>

					<input
						name="rating"
						type="number"
						placeholder="Рейтинг"
						value={rating}
						onChange={(e) => setRating(e.target.value)}
					/>
					<input
						name="categories"
						type="text"
						placeholder="Категории"
						value={categories}
						onChange={(e) => setCategories(e.target.value)}
					/>
					<input
						name="devices"
						type="text"
						placeholder="Девайсы"
						value={devices}
						onChange={(e) => setDevices(e.target.value)}
					/>

					<div className={styles.buttons}>
						<button type="button" onClick={handleSubmit}>
							{item ? 'Сохранить' : 'Добавить'}
						</button>
						<button type="button" onClick={onClose}>
							Отмена
						</button>
					</div>
				</form>
			</div>
		</div>
	);
};
